import React, { useState } from "react";
import useHandler from "./handler";
import "./styles.sass";
import assets from "../../assets";
import { useNavigate } from "react-router-dom";
import { ROUTE_DASHBOARD } from "../../route/communicative";

export const ReadingPractice = () => {
  const {
    TOPICS,
    TOPICS_BY_DIFFICULTY,
    LEVELS,
    data,
    answers,
    loading,
    topics,
    submitted,
    score,
    classLevel,
    topic,
    difficulty,
    showPractice,
    setShowPractice,
    audioRef,
    setClassLevel,
    setTopic,
    setDifficulty,
    setData,
    setAnswers,
    setLoading,
    selectAnswer,
    submitAnswers,
    setSubmitted,
    getReadingPassage,
    submitReadingPassage,
  } = useHandler();
  const navigate = useNavigate();

  const answeredCount = Object.keys(answers).length;
  const totalQuestions = data?.questions?.length || 0;

  const Header = () => {
    return (
      <header className="communicative_reading_app_header">
        <div className="communicative_reading_app_header_left">
          <img src={assets.ic_logo} alt="logo" />

          <span>Rovian AI</span>
        </div>

        <div
          className="communicative_reading_app_header_right"
          onClick={() => navigate(ROUTE_DASHBOARD)}
        >
          {/* <img
            src={assets.ic_right_arrow || ""}
            alt=""
            style={{ transform: "rotate(0deg)", width: "12px" }}
          />{" "} */}
          <span className="back-arrow">←</span>
          Dashboard
        </div>
      </header>
    );
  };

  return (
    <>
      <Header />
      <section className="communicative_reading_main">
        <section className="communicative_reading">
          {showPractice && (
            <div className="communicative_reading_header_bar">
              <div className="header_text_group">
                <button
                  type="button"
                  className="reading_back_btn"
                  onClick={() => setShowPractice(false)}
                >
                  ← Change Topic
                </button>
                <h2 className="communicative_reading_title">Reading Practice</h2>
                <h4 className="communicative_reading_description">
                  Read the passage carefully and answer the questions below.
                </h4>
              </div>
              <div className="communicative_reading_badges">
                {difficulty && (
                  <span className="reading_badge difficulty_badge">{difficulty}</span>
                )}
                {topic && <span className="reading_badge topic_badge">{topic}</span>}
              </div>
            </div>
          )}
          {!showPractice ? (
            <section className="communicative_reading_initial">
              <h2 className="communicative_reading_title">Reading Practice</h2>
              <h4 className="communicative_reading_description">
                Select your preferences to start a reading passage with MCQ
                questions.
              </h4>
              <div className="communicative_reading_practice_form">
                <div className="communicative_reading_field">
                  <label>Difficulty</label>

                  <div className="communicative_reading_difficulty">
                    {LEVELS.map((item) => (
                      <button
                        key={item}
                        type="button"
                        className={
                          difficulty === item
                            ? "communicative_reading_active"
                            : "communicative_reading_difficulty_btn"
                        }
                        onClick={() => setDifficulty(item)}
                      >
                        {item}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="communicative_reading_field">
                  <label>Topic</label>

                  <input
                    placeholder="Enter topic"
                    value={topic}
                    onChange={(e) => setTopic(e.target.value)}
                    className="communicative_reading_topic_input"
                  />

                  <div className="communicative_reading_chips_header">
                    <span className="communicative_reading_chips_label">Suggested Topics</span>
                  </div>

                  <div className="communicative_reading_chips">
                    {((difficulty && TOPICS_BY_DIFFICULTY?.[difficulty]) || TOPICS_BY_DIFFICULTY?.Beginner || TOPICS).map((item) => (
                      <button
                        key={item}
                        type="button"
                        className={`communicative_reading_chip ${topic === item ? "active" : ""}`}
                        onClick={() => setTopic(item)}
                      >
                        <span className="tag_dot" />
                        <span className="tag_text">{item}</span>
                        {topic === item && <span className="tag_check">✓</span>}
                      </button>
                    ))}
                  </div>
                </div>

                <button
                  className="communicative_reading_start_btn"
                  disabled={!topic || !difficulty || loading}
                  onClick={() =>
                    getReadingPassage(classLevel, topic, difficulty)
                  }
                >
                  {loading ? "Loading..." : "Start Practice"}
                </button>
              </div>
            </section>
          ) : loading ? (
            <div className="communicative_reading_loading">
              <div className="communicative_reading_spinner" />
              <span>Generating passage...</span>
            </div>
          ) : (
            <div className="communicative_reading_content_wrapper">
              {submitted && (
                <section className="communicative_reading_feedback">
                  <div className="feedback_top_row">
                    <div className="communicative_reading_feedback_title">
                      <img src={assets.ic_magic_green} alt="ic_magic_green" />
                      <h4>AI Feedback</h4>
                    </div>
                    <button
                      type="button"
                      className="feedback_retry_btn"
                      onClick={() => setShowPractice(false)}
                    >
                      Try Another Passage
                    </button>
                  </div>

                  <p className="feedback_desc">
                    {data?.feedback ||
                      "You completed the reading practice successfully. Keep reading regularly to improve."}
                  </p>

                  <div className="communicative_reading_feedback_cards">
                    <div className="communicative_reading_stat_card">
                      <h5>CORRECT</h5>
                      <h2>{data?.correctCount || 0} / {totalQuestions}</h2>
                      <div className="communicative_reading_progress">
                        <div
                          className="communicative_reading_progress_line purple"
                          style={{
                            width: `${totalQuestions ? ((data?.correctCount || 0) / totalQuestions) * 100 : 0}%`,
                          }}
                        />
                      </div>
                    </div>

                    <div className="communicative_reading_stat_card">
                      <h5>COMPREHENSION</h5>
                      <h2>{data?.comprehensionScore || 0}%</h2>
                      <div className="communicative_reading_progress">
                        <div
                          className="communicative_reading_progress_line orange"
                          style={{ width: `${data?.comprehensionScore || 0}%` }}
                        />
                      </div>
                    </div>

                    <div className="communicative_reading_stat_card">
                      <h5>ACCURACY</h5>
                      <h2>{data?.accuracyScore || 0}%</h2>
                      <div className="communicative_reading_progress">
                        <div
                          className="communicative_reading_progress_line blue"
                          style={{ width: `${data?.accuracyScore || 0}%` }}
                        />
                      </div>
                    </div>
                  </div>
                </section>
              )}

              <div className="communicative_reading_content">
                <section className="communicative_reading_passage">
                  <div className="communicative_reading_passage_header">
                    <span className="passage_tag">Reading Passage</span>
                    <h2>{data?.title}</h2>
                  </div>

                  <div className="communicative_reading_passage_body">
                    <p>{data?.passage}</p>
                  </div>

                  {data?.audio_url && (
                    <div className="communicative_reading_audio_wrapper">
                      <audio
                        ref={audioRef}
                        controls
                        preload="metadata"
                        className="communicative_reading_audio"
                      >
                        <source src={data?.audio_url} type="audio/mpeg" />
                        Your browser does not support audio.
                      </audio>
                    </div>
                  )}
                </section>

                <section className="communicative_reading_questions_panel">
                  <div className="communicative_reading_panel_header">
                    <h3>Comprehension Questions</h3>
                    <span className="questions_count_badge">
                      {answeredCount} of {totalQuestions} Answered
                    </span>
                  </div>

                  <div className="communicative_reading_questions_list">
                    {data?.questions?.map((item, index) => {
                      const result = data?.results?.find(
                        (r) => r.q_index === index,
                      );
                      const isAnswered = answers[index] !== undefined;

                      return (
                        <div
                          key={index}
                          className={`communicative_reading_ques_card ${isAnswered ? "is_answered" : ""}`}
                        >
                          <div className="ques_card_header">
                            <span className="ques_badge">{index + 1}</span>
                            <h4 className="ques_title">{item.question}</h4>
                          </div>

                          <div className="communicative_reading_options_grid">
                            {Object.entries(item.options || {})?.map(
                              ([key, option], optionIndex) => {
                                const selected = answers[index] === key;
                                const correct =
                                  submitted && result?.correct_answer === key;
                                const wrong =
                                  submitted && selected && !result?.is_correct;

                                return (
                                  <button
                                    key={optionIndex}
                                    type="button"
                                    className={`communicative_reading_card_btn ${!submitted && selected ? "communicative_reading_selected" : ""} ${correct ? "communicative_reading_correct" : ""} ${wrong && selected ? "communicative_reading_wrong" : ""}`}
                                    onClick={() =>
                                      !submitted && selectAnswer(index, key)
                                    }
                                  >
                                    <div className="option_left">
                                      <span className="option_letter">{key}</span>
                                      <span className="option_text">{option}</span>
                                    </div>

                                    {submitted && (
                                      <>
                                        {correct && (
                                          <span className="communicative_reading_answer_tag">
                                            ✓ Correct
                                          </span>
                                        )}
                                        {wrong && selected && (
                                          <span className="communicative_reading_answer_tag wrong_text">
                                            ✗ Your Choice
                                          </span>
                                        )}
                                      </>
                                    )}
                                  </button>
                                );
                              },
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="communicative_reading_panel_footer">
                    <button
                      className="communicative_reading_submit"
                      disabled={submitted || loading || totalQuestions === 0}
                      onClick={submitReadingPassage}
                    >
                      {submitted
                        ? "Submitted"
                        : loading
                          ? "Submitting..."
                          : answeredCount < totalQuestions
                            ? `Submit (${answeredCount}/${totalQuestions} Answered)`
                            : "Submit Answers"}
                    </button>
                  </div>
                </section>
              </div>
            </div>
          )}
        </section>
      </section>
    </>
  );
};
